/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H133162 on 2/4/2021.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {injectIntl, FormattedMessage} from 'react-intl';
import {Button, TextArea, Modal, Select} from '@scuf/common';
import * as FaultActions from "../FaultActions";
import * as SecurityActions from '../../security/SecurityActions'
import {FAULT_STATES} from "./FaultsConst"
import Loader from '../../common/Loader'
import {faultCloseModel} from '../../model/Fault'
import {getFieldErrorMessage, verifyAirtimeException} from '../../utils/Helpers'
import {userHasActivity} from "../../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";
import {fetchCloseComments} from "../../api/Faults";

class CloseFaultModal extends React.Component {
    constructor(props) {
        super(props)

        const {intl} = this.props

        this.state = {
            closeComment: '',
            closeCommentText: '',
            errors: [],
            closeCommentsOptions: [],
            closeCommentIndex: null,
        }

        this.faultCloseModel = faultCloseModel(intl)

        this.handleCloseCommentChange = this.handleCloseCommentChange.bind(this)
        this.handleTextChange = this.handleTextChange.bind(this)
        this.changeFaultState = this.changeFaultState.bind(this)
        this.submitCloseFault = this.submitCloseFault.bind(this)
        this.fetchCloseCommentsOptions = this.fetchCloseCommentsOptions.bind(this)
    }

    componentDidMount() {
        this.fetchCloseCommentsOptions();
    }

    fetchCloseCommentsOptions() {
        fetchCloseComments()
            .then(response => {
                this.setState({closeCommentsOptions: response})
            });
    }

    handleCloseCommentChange(selectedOption) {
        const selectedText = this.state.closeCommentsOptions[selectedOption].name;
        this.setState({closeComment: selectedText, closeCommentIndex: selectedOption});
    }

    handleTextChange(value) {
        this.setState({closeCommentText: value});
    }

    changeFaultState(state, comment) {
        const {fault} = this.props;
        return this.props.FaultActions.setFaultState(fault.assetId, fault.faultId, state, undefined, comment,
            userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY))
            .catch(ex => {
                verifyForgeException(ex.errorKey, this.props.SecurityActions.signOut)
            })
    }

    closeCommentModal() {
        const {intl} = this.props;

        const options = this.state.closeCommentsOptions.map((a, i) => {
            return {value: i, text: a.name}
        })

        const helperText1 = intl.formatMessage({id: "fault.detail.action.close.comment.helperTextArea"});
        const helperText2 = intl.formatMessage({id: "fault.detail.comment.warning"})

        return (
            <Modal closeIcon={false} onClose={() => this.props.closeModalWindow()} open={this.props.closeModalOpen}
                   closeOnDimmerClick={true} className="closed-modal">
                <Modal.Header>
                    <FormattedMessage id="fault.detail.action.close.title"/>
                </Modal.Header>
                <Modal.Content>
                    <Select
                        label={intl.formatMessage({id: "fault.detail.action.close.comment.select.title"})}
                        closeOnChange={true}
                        fluid
                        button={true}
                        multiple={false}
                        placeholder={intl.formatMessage({id: "fault.detail.action.close.comment.select"}) + " "}
                        options={options}
                        value={this.state.closeCommentIndex}
                        error={getFieldErrorMessage('comment', this.state.errors)}
                        onChange={(selectedOption) => this.handleCloseCommentChange(selectedOption)}
                        helperText={intl.formatMessage({id: "fault.detail.action.close.comment.helperText"})}
                        style={{textTransform: 'none'}}/>
                    <TextArea
                        label={intl.formatMessage({id: "fault.detail.action.close.comment.other"})}
                        value={this.state.closeCommentText}
                        onChange={this.handleTextChange} fluid
                        error={getFieldErrorMessage('commentText', this.state.errors)}
                        helperText={
                            <div>
                                <div>{helperText1}</div>
                                <div>{helperText2}</div>
                            </div>
                        }
                    />
                </Modal.Content>
                <Modal.Footer>
                    <div className="closedModal-buttons">
                        <Button className="mobile-max-width-button"
                                content={intl.formatMessage({id: "fault.detail.action.cancel"})}
                                onClick={() => this.props.closeModalWindow()} size="medium" type="secondary"/>
                        <Button className="mobile-max-width-button"
                                content={intl.formatMessage({id: "fault.detail.action.close.submit"})}
                                onClick={this.submitCloseFault} size="medium" type="primary"/>
                    </div>
                </Modal.Footer>
                <Loader loading={this.props.loading}/>
            </Modal>
        )
    }

    submitCloseFault() {
        this.faultCloseModel.validate({
            comment: this.state.closeComment,
            commentText: this.state.closeCommentText
        }, {abortEarly: false})
            .then(() => {
                    this.setState({errors: []})
                    this.changeFaultState(FAULT_STATES.VERIFICATION, this.state.closeComment + ". " + this.state.closeCommentText).then(() => {
                        if (this.props.fault.details.faultConditionState === FAULT_STATES.VERIFICATION ||
                            (userHasActivity(this.props.userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) &&
                                this.props.fault.details.faultConditionState === FAULT_STATES.CLOSED_RESOLVED)) {
                            this.setState({closeModalOpen: false})
                            this.props.troubleshootingNavigation()
                            this.props.closeModalWindow()
                        }
                    })
                }
            )
            .catch(err => {
                this.setState({
                    errors: err.inner.map(i => {
                        return {path: i.path, message: i.errors}
                    }),
                })
            })
    }

    render() {
        return (
            <div>
                {this.closeCommentModal()}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        fault: state.fault,
        loading: state.fault.fetchCount > 0,
        security: state.security,
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FaultActions: bindActionCreators(FaultActions, dispatch),
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(CloseFaultModal)))